export enum ModerationContentType {
    problem = 0,
    suggestion = 1,
    comment = 2,
    solution = 3,
    workaround = 4,
}

export enum ModerationStatus {
        /* notes: 
         - NULL valid in DB means "not processed yet" or "clean" depending on IsContentClean valud; 
         - 0 is invalid (missing) status
         nikolami: stats as of 2024-12-03, before adding new statuses:
            NULL 2676974
            1	5
            2	4483
            3	22252
            4	119
            5	51
        */

        /// <summary>
        /// Flagged as potential spam by one of the following:
        /// 1. CVS (Content Verification Service)
        /// 2. Moderation Rule (e.g. throttling)
        /// 3. User Flagged through DevCom UI
        /// </summary>
        FlaggedForReview = 1,

        /// <summary>
        /// Rejected manually by human moderator
        /// </summary>
        RejectedByModerator = 2,

        /// <summary>
        /// Accepted manually by human moderator
        /// </summary>
        AcceptedByModerator = 3,

        /// <summary>
        /// Rejected due to CVS auto-detecting as spam.
        /// </summary>
        RejectedByCVS = 4,

        /// <summary>
        /// Potential spam flagged by AI-based content moderation.
        /// </summary>
        FlaggedByAI = 5,

        /// <summary>
        /// Flagged due to external user attempting to post in an internal space.
        /// Happens when external customer tries to post using VS build marked as internal (usually an error and build should be external)
        /// Note: this flag may be overridden by AI/CVS/rule to auto-reject later in the initial processing pipeline.
        /// </summary>
        FlaggedExternalUserInInternalSpace = 6,
}

export enum ModerationListFilter {
    postsAwaitingModeration = 1,
    allReportedPosts = 2,
    recentlyCreatedPosts = 3,
    autoRejectedPosts = 4,
}

export class ModerationPost {
    public moderationStatus: ModerationStatus | null;
    public contentId: number;   // Id of comment, solution or problem
    public contentType: ModerationContentType;
    public content: string;

    public rootPostId: number;
    public rootPostTitle: string;

    public createdById: number;
    public createdByVsId: string;
    public createdByName: string;
    public createdByImageLink: string;
    public createdDateUtc: string;
    public isAuthorSuspended: boolean;
    public wasPostDeletedByUser: boolean;
}

export class User {
    public principalId: number;
    public vsid: string;
    public displayName: string;
    public email: string;
    public createdDate: string;
    public isSuspended: boolean;
    public profileImageUrl: string;
}
